import {
  ALL_STAKEHOLDER_TYPES_ORDER,
  DEFAULT_STAKEHOLDER_PRIMARY_HEX,
  REGISTRATION_PROFILE_JSON_KEY,
  normalizeStakeholderCode,
  stakeholderPrimaryHexFromCanonical,
} from '@buxus/shared'
import { PROFILE_STAKEHOLDER_STORAGE_KEY } from '../abp/config'

function coerceStakeholderTypeString(v: unknown): string | null {
  if (typeof v === 'string' && v.trim().length > 0) return v.trim()
  if (typeof v === 'number' && Number.isFinite(v)) return String(v)
  return null
}

function readStakeholderTypeFromRegistrationBlob(data: unknown): string | null {
  const root = data && typeof data === 'object' ? (data as Record<string, unknown>) : null
  if (!root) return null

  const direct = coerceStakeholderTypeString(root.stakeholderType)
  if (direct) return direct

  const reg =
    root.registration && typeof root.registration === 'object'
      ? (root.registration as Record<string, unknown>)
      : null
  if (reg) {
    const fromReg = coerceStakeholderTypeString(reg.stakeholderType)
    if (fromReg) return fromReg
  }
  return null
}

/** Profile stakeholder string from dedicated cache or registration profile JSON. */
export function readProfileStakeholderFromAllStorage(): string | null {
  try {
    const fromKey = localStorage.getItem(PROFILE_STAKEHOLDER_STORAGE_KEY)?.trim()
    if (fromKey) return fromKey
  } catch {
    /* ignore */
  }
  try {
    const raw = localStorage.getItem(REGISTRATION_PROFILE_JSON_KEY)
    if (!raw?.trim()) return null
    return readStakeholderTypeFromRegistrationBlob(JSON.parse(raw) as unknown)
  } catch {
    return null
  }
}

/** Stakeholder → hex for the in-app shell app bar (`App.tsx` `--stakeholder-primary`). */
export function resolveAppBarPrimaryHex(
  profileStakeholderRaw: string | null | undefined,
  effectiveStakeholderCode: string | null | undefined,
): string {
  const raw =
    (effectiveStakeholderCode?.trim() || profileStakeholderRaw?.trim() || readProfileStakeholderFromAllStorage()) ||
    ''
  if (!raw) return DEFAULT_STAKEHOLDER_PRIMARY_HEX
  const canon = normalizeStakeholderCode(raw, ALL_STAKEHOLDER_TYPES_ORDER)
  return stakeholderPrimaryHexFromCanonical(canon)
}
